import React, { PropsWithChildren } from 'react';
import styles from './dictionary-components.module.scss';

export default function AkYellowBg({ children }: PropsWithChildren<{}>) {
    return <span className={styles.wwiseAkBlueYellowBg}>{children}</span>;
}
